import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Gets the company Import Status
 * @returns Data object indicating import status
 */
export function getCompanyImportStatus(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyImportStatusUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.object({ statusCode: z.number() }),
      })
    )
  );
}
